export const OSS_CONFIG = {
  // OSS域名
  domain: 'https://xianmao-static.oss-cn-guangzhou.aliyuncs.com',
  // 图片路径前缀
  imagePrefix: '/xianlaibang/web',
  // 其他OSS相关配置
  bucket: 'xianmao-static',
  region: 'oss-cn-guangzhou',
}
